// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2hvMW","colMaxWidth":"Table_colMaxWidth__3eRxU"};